export default __webpack_public_path__ + "static/media/Subh.09383ab1.jpg";